import { Component } from '@angular/core';

@Component({
  selector: 'app-empty-chart',
  templateUrl: './empty.component.html',
  styleUrls: ['./empty.component.scss']
})
export class EmptyChartComponent { }
